import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DatePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { AvEmptyStateComponent } from '../../../../Shared/Components/av-empty-state/av-empty-state.component';
import { AvPaginatorComponent } from '../../../../Shared/Components/av-paginator/av-paginator.component';
import { AvStatusChipComponent } from '../../../../Shared/Components/av-status-chip/av-status-chip.component';
import { OrganizationDeviceFacade } from '../../../../../Facades/Organizations/organization-device.facade';
import { DATE_TIME_FORMAT, VALUE_UNRESOLVED } from '../../../../../Consts/backoffice.const';
import { DEVICE_STATE_LABEL, DEVICE_STATE_OPTIONS } from '../../../../../Enums/device-state.enum';

@Component({
  selector: 'av-organization-devices',
  standalone: true,
  imports: [
    RouterLink,
    DatePipe,
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
    AvEmptyStateComponent,
    AvPaginatorComponent,
    AvStatusChipComponent,
  ],
  templateUrl: './organization-devices.component.html',
  styleUrl: './organization-devices.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
})
export class OrganizationDevicesComponent {
  readonly facade = inject(OrganizationDeviceFacade);

  readonly organizationId = input<string>('');

  readonly dateTimeFormat = DATE_TIME_FORMAT;
  readonly unresolved = VALUE_UNRESOLVED;
  readonly stateOptions = DEVICE_STATE_OPTIONS;
  readonly stateLabelKeys = DEVICE_STATE_LABEL;

  countFor(state: string): number {
    return this.facade.counts()[state] ?? 0;
  }

  search(value: string): void {
    this.facade.applyFilters({ ...this.facade.filters(), search: value });
  }

  filterState(value: string): void {
    this.facade.applyFilters({ ...this.facade.filters(), state: value });
  }

  clearFilters(): void {
    this.facade.clearFilters();
  }

  goToPage(page: number): void {
    this.facade.goToPage(page);
  }

  changePageSize(pageSize: number): void {
    this.facade.changePageSize(pageSize);
  }
}
